<template>
  <v-card elevation="10" width="350" :loading="loading">
    <v-card-text>
      <div class="text-center mb-5">
        <img src="../assets/logo.png" width="120" alt="Logo da D3V" />
      </div>
      <h2 class="font-weight-light my-5 text-center">Escada 4.0 - D3V & BGA</h2>
      <v-form @submit.prevent="entrar()">
        <v-text-field
          v-model="login"
          :error-messages="errosLogin"
          v-touch="login"
          prepend-icon="mdi mdi-account"
          label="Usuário"
        />
        <v-text-field
          v-model="senha"
          :error-messages="errosSenha"
          v-touch="senha"
          :type="passwordType"
          prepend-icon="mdi mdi-lock"
          :append-icon="passwordIcon"
          label="Senha"
          @click:append="hiddenPassword = !hiddenPassword"
        />
        <v-btn type="submit" :loading="loading" depressed block color="accent" class="mt-2">
          <v-icon class="mdi mdi-login mr-2" />ENTRAR
        </v-btn>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { required } from "vuelidate/lib/validators";
export default {
  data() {
    return {
      hiddenPassword: true,
      login: "",
      senha: "",
      loading: false
    };
  },
  validations: {
    login: {
      required
    },
    senha: {
      required
    }
  },
  computed: {
    passwordType() {
      return this.hiddenPassword ? "password" : "text";
    },
    passwordIcon() {
      return this.hiddenPassword ? "mdi mdi-eye-off" : "mdi mdi-eye";
    },
    errosLogin() {
      const errors = [];
      if (this.$v.login.$dirty && !this.$v.login.required) {
        errors.push("O nome de usuário é obrigatório.");
      }
      return errors;
    },
    errosSenha() {
      const errors = [];
      if (this.$v.senha.$dirty && !this.$v.senha.required) {
        errors.push("A senha é obrigatória.");
      }
      return errors;
    }
  },
  methods: {
    async entrar() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loading = true;
        const success = await this.$store.dispatch("usuarios/login", {
          login: this.login,
          senha: this.senha
        });
        this.loading = false;
        if (success) {
          this.$router.replace({ name: "dashboard" });
        }
      }
    }
  }
};
</script>
